import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=7d44a0f0&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
import style0 from "./Resizer.vue?vue&type=style&index=0&id=7d44a0f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports